import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // בדיקה אם המשתמש כבר אישר קוקיז
    const checkCookieConsent = () => {
      try {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
          // הצגת הבאנר אחרי 800ms (קצת יותר זמן לטעינת הדף)
          setTimeout(() => {
            setIsVisible(true);
          }, 800);
        }
      } catch (error) {
        console.error('Error checking cookie consent:', error);
        // אם יש בעיה עם localStorage, עדיין נציג את הבאנר
        setTimeout(() => {
          setIsVisible(true);
        }, 800);
      }
    };

    checkCookieConsent();
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setIsVisible(false);
    } catch (error) {
      console.error('Error saving cookie consent:', error);
      setIsVisible(false);
    }
  };

  const handleDecline = () => {
    try {
      localStorage.setItem('cookieConsent', 'declined');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setIsVisible(false);
    } catch (error) {
      console.error('Error saving cookie consent:', error);
      setIsVisible(false);
    }
  };

  // לא להציג כלום עד שהקומפוננטה נטענה (למנוע flash)
  if (!mounted || !isVisible) return null;

  return (
    <>
      {/* Overlay כהה מאחורי הבאנר */}
      <div 
        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[49] transition-opacity duration-300"
        onClick={handleDecline}
      />
      
      {/* באנר קוקיז */}
      <div 
        className="fixed bottom-0 left-0 right-0 z-[60] lg:bottom-4 lg:left-4 lg:right-auto lg:max-w-md animate-slideUp" 
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        dir="rtl"
      >
        <div className="bg-white/95 backdrop-blur-md border-2 border-black rounded-2xl shadow-2xl p-6 m-4 mb-24 lg:mb-4 lg:m-0">
          <div className="flex flex-col gap-4">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center flex-shrink-0">
                <Cookie className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-gray-800 font-bold text-lg mb-2">
                  שימוש בקוקיז
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  אנו משתמשים בקוקיז כדי לשפר את חוויית הגלישה שלך. על ידי המשך השימוש באתר, אתה מסכים לשימוש בקוקיז בהתאם למדיניות הפרטיות שלנו.
                </p>
              </div>
              <button
                onClick={handleDecline}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0"
                aria-label="סגור"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={handleAccept}
                className="flex-1 px-6 py-3 bg-black text-white font-semibold rounded-xl hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                אני מסכים
              </button>
              <button
                onClick={handleDecline}
                className="flex-1 px-6 py-3 bg-transparent border-2 border-black text-black font-semibold rounded-xl hover:bg-gray-100 transition-all duration-300"
              >
                דחה
              </button>
            </div>
            
            <div className="text-xs text-gray-500 text-center space-y-1">
              <div className="flex flex-wrap justify-center gap-2">
                <a href="/privacy" className="text-amber-600 hover:text-amber-700 transition-colors underline">
                  מדיניות פרטיות
                </a>
                <span className="text-gray-400">•</span>
                <a href="/terms" className="text-amber-600 hover:text-amber-700 transition-colors underline">
                  תנאי שימוש
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(100%);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
      `}</style>
    </>
  );
};

export default CookieBanner;
